import request from '@/utils/request'
// 获取总览的数据
export function fetchOverview(params = {}) {
  return request({
    url: '/merchant-api/trade/overview',
    method: 'get',
    params
  })
}

// 获取payment分析数据
export function fetchPaymentData(params = {}) {
  return request({
    url: '/merchant-api/trade/analyse/payment',
    method: 'get',
    params
  })
}

// 获取disbursement 分析数据
export function fetchDisbursementData(params = {}) {
  return request({
    url: '/merchant-api/trade/analyse/disbursement',
    method: 'get',
    params
  })
}

export function fetchTodayTotalData(params = {}) {
  return request({
    url: '/merchant-api/trade/total/statistics',
    method: 'get',
    params
  })
}
